import { reduce } from "et3-type-guards";

import { TReportDetailProps } from "../../../Types";
import ET3Div from "../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import ActionButtons from "./action-buttons";
import DetailsReportBox from "./details-report-box";

const ReportDetail = withLiteObserverAndTheme<TReportDetailProps>((props) => {
  const { isDetailVisible, report, status, pageName, theme } = props;
  const { colors } = theme;
  const { reporterId, reportedId, reportId, reportedUUID } = report;
  const reportedIsSilentBanned = reduce(() => report.reportedIsSilentBanned, 0);

  return isDetailVisible ? (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="flex-start"
      alignItems="flex-end"
      withShadow={false}
      width={1500}
      height={1250}
      color={colors.all.whiteBlue}
      style={{}}
      onClick={() => {}}
    >
      <Et3Margin top={0} bottom={0} right={30} left={30} />
      <DetailsReportBox report={report} status={status} pageName={pageName} />
      <ActionButtons
        reportedId={reportedId}
        reportedIsSilentBanned={reportedIsSilentBanned}
        reportedUUID={reportedUUID}
        reportId={reportId}
        reporterId={reporterId}
        status={status}
        pageName={pageName}
      />
    </ET3Div>
  ) : null;
});
export default ReportDetail;
